import type {
    BaseColumnCategory,
    ColumnCategoryConfig,
} from "app/pages/sales-intelligence/common-components/column-picker";

import type { LeadsColumnCategoryDto } from "../../types";

type ColumnCategoriesConfig<Category extends LeadsColumnCategoryDto = LeadsColumnCategoryDto> = {
    readonly initialCategories: readonly (Category | BaseColumnCategory)[];

    getCategoryConfig: (categoryId: Category) => ColumnCategoryConfig<Category>;
};

export const createColumnCategoriesConfig = <
    Category extends LeadsColumnCategoryDto = LeadsColumnCategoryDto,
>(): ColumnCategoriesConfig<Category> => ({
    get initialCategories() {
        return ["all"] as const;
    },

    getCategoryConfig(categoryId): ColumnCategoryConfig<Category> {
        return {
            labelKey: `si.leads-search.column-picker.category.${categoryId}`,
            name: categoryId,
        };
    },
});
